import { AppDispatch, RootState } from '@internal/redux'
import { MediaQueryParam } from '@shared/Services/QueryParamService'
import MediaService, { MediaMapping } from '@internal/services/MediaService'
import { fetchMediaThunk } from './redux.thunks'
import { IReduxMapDispatch, IReduxMapState } from './redux.types'
import MediaSlice from './redux.slice'

export const mapStateToProps = (state: RootState): IReduxMapState => ({
  status: state.MediaSlice.status,
  slice: state.MediaSlice,
  tableInfo: state.MediaSlice.tableInfo,
  categories: state.MediaSlice.categories
})

type TRequest = { abort: () => void }
const FetchAccessory: { request?: TRequest } = {}
export const mapDispatchToProps = (dispatch: AppDispatch): IReduxMapDispatch => ({
  fetchData: () => {
    return dispatch(fetchMediaThunk())
  },
  onChangeStatus: (status) => {
    dispatch(MediaSlice.actions.onChangeStatus(status))
  },
  onChangeTableInfo: (key, value, details) => {
    if (key === 'FilterModel') {
      dispatch(MediaSlice.actions.onChange({ key, value, details }))
    }
    FetchAccessory.request?.abort()
    FetchAccessory.request = dispatch(fetchMediaThunk({ tableInfoChange: { key, value: value, details } }))
  },
  CRUD: {
    Create: async (model) => {
      const dataMapping = MediaMapping.mediaCreate(model)
      const id = MediaQueryParam.get().deliveryId
      if (!!id) {
        await MediaService.DeleveryDetailCreate({ ...dataMapping, DeliveryId: id })
      } else {
        await MediaService.Create(dataMapping)
      }
      dispatch(fetchMediaThunk({}))
    },
    Update: async (Id, model) => {
      const dataMapping = MediaMapping.mediaCreate(model)
      await MediaService.Update(Id, dataMapping)
      dispatch(fetchMediaThunk())
    },
    Delete: async (Id) => {
      await MediaService.Remove(Id)
      dispatch(fetchMediaThunk())
    }
  },
  updateDelivery: async (id, value) => {
    dispatch(MediaSlice.actions.updateDelivery({ Id: id, ...value }))
  },
  clean: () => {
    dispatch(MediaSlice.actions.clean())
  }
})
